import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {LocalDataService} from './local-data.service';

import {environment} from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class WebService {

	constructor(private http: HttpClient, private localDataService: LocalDataService) {
	}

	async unauthGet(conf) {
		try {
			const params = [];

			conf.params = typeof conf.params === 'undefined' ? {} : conf.params;
			for (const i in conf.params) {
				params.push(i + '=' + encodeURIComponent(conf.params[i]));
			}

			let paramsFormated = '?' + params.join('&');
			if (paramsFormated === '?&' || paramsFormated === '?') {
				paramsFormated = '';
			}

			let url = environment.base_url + conf.url + paramsFormated;

			try {
				return this.http.get(url).toPromise();
			} catch (error) {
				throw error;
			}
		} catch (error) {
			throw error;
		}
	}

	async unauthExternalGet(conf, json = true) {
		try {
			const params = [];

			conf.params = typeof conf.params === 'undefined' ? {} : conf.params;
			for (const i in conf.params) {
				params.push(i + '=' + encodeURIComponent(conf.params[i]));
			}

			let paramsFormated = '?' + params.join('&');
			if (paramsFormated === '?&' || paramsFormated === '?') {
				paramsFormated = '';
			}

			let url = conf.url + paramsFormated;

			try {
				const result = await fetch(url);
				if (!result.ok) {
					throw result.status;
				}
				if (json) {
					return result.json();
				} else {
					return result.text();
				}
			} catch (error) {
				throw error;
			}
		} catch (error) {
			throw error;
		}
	}

	async unauthPost(conf) {
		try {
			let url = environment.base_url + conf.url;
			return this.http.post(url, conf.params).toPromise();
		} catch (error) {
			throw error;
		}
	}

	async getToken() {
		const token = await this.localDataService.getItem('token');
		if (token != null) {
			return token;
		} else {
			throw 'TOKEN';
		}
	}

	async get(conf) {
		try {
			const token = await this.getToken();
			const params = [];

			conf.params = typeof conf.params === 'undefined' ? {} : conf.params;
			for (const i in conf.params) {
				params.push(i + '=' + encodeURIComponent(conf.params[i]));
			}

			let paramsFormated = '?' + params.join('&');
			if (paramsFormated === '?&' || paramsFormated === '?') {
				paramsFormated = '';
			}

			let url = environment.base_url + conf.url + paramsFormated;

			let httpHeaders = new HttpHeaders({
				DOLAPIKEY: token
			});
			const options = {headers: httpHeaders};

			try {
				return this.http.get(url, options).toPromise();
			} catch (error) {
				throw error;
			}
		} catch (error) {
			throw error;
		}
	}

	async post(conf) {
		try {
			const token = await this.getToken();
			let url = environment.base_url + conf.url;

			let httpHeaders = new HttpHeaders({
				DOLAPIKEY: token
			});
			const options = {headers: httpHeaders};

			try {
				return this.http.post(url, conf.params, options).toPromise();
			} catch (error) {
				throw error;
			}
		} catch (error) {
			throw error;
		}
	}

	async put(conf) {
		try {
			const token = await this.getToken();
			let url = environment.base_url + conf.url;

			let httpHeaders = new HttpHeaders({
				DOLAPIKEY: token
			});
			const options = {headers: httpHeaders};

			try {
				return this.http.put(url, conf.params, options).toPromise();
			} catch (error) {
				throw error;
			}
		} catch (error) {
			throw error;
		}
	}

	async delete(conf) {
		try {
			const token = await this.getToken();

			let url = environment.base_url + conf.url;

			let httpHeaders = new HttpHeaders({
				DOLAPIKEY: token
			});
			const options = {headers: httpHeaders, params: conf.params};

			try {
				return await this.http.delete(url, options).toPromise();
			} catch (error) {
				throw error;
			}
		} catch (error) {
			throw error;
		}
	}
}
